import { useEffect, useRef, useState, useMemo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Formik, Field } from 'formik';
import { Button, Col, Container, Row, Form } from 'react-bootstrap';
import { useStore } from 'store';
import {
  fetchGiftsTables,
  setGiftTableSearchValues,
} from 'store/actions/giftTable';
import { resetExternalGiftTable } from 'store/actions/externalGiftTable';
import { fetchEventTypes } from 'store/actions/catalogs';
// eslint-disable-next-line no-unused-vars
import { Select, Input, DatePicker, Card, CustomIcon, Modal, PaginationList, CustomDatePicker } from 'components';
// import GiftsLayout from 'components/gifts-table/GiftsLayout';
// import { TableList } from 'components/gifts-table/TableList';
import { searchGiftTableFormatter } from 'services/giftTable/formatters';
// eslint-disable-next-line no-unused-vars
import searchIcon2 from 'assets/img/search-icon.svg';
import { FLAT } from 'constants/transformers';
import { transformForSelect } from 'util/transformHelpers';
import { isThereEvenAValue } from 'util/validations';
import { getGiftTableLink } from 'services/commons';
import { useWindowSize, useStorage64 } from 'hooks';
// import trash from 'assets/img/trash.svg';
import searchIcon from 'assets/img/buscar.png';
// import { setLoginRedirectSSO } from 'util/navigation';
import _noop from 'lodash/noop';
import { initialValues, schema } from './config';
// import { columns } from './columns';
import styles from './styles.module.scss';
import { wapLink } from '../../../constants/Wap/index';
import DeleteTableFlux from '../DeleteTableFlux'

const SearchTableStep = ({onDeleteGift = _noop}) => {
  const [showDeleteTableFlux, setShowDeleteTableFlux] = useState(false);
  const [showSearchGiftTable, setShowSearchGiftTable] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [state, dispatch] = useStore();
  const { giftTable, catalogs } = state;
  const { giftTableSearchValues = {}, listOfGiftsTables } = giftTable;
  const { flatEventTypes: eventTypes = [] } = catalogs;
  const [isLogged] = useStorage64('session_token', '');
  const isLoggedIn = !!(isLogged && isLogged.length);
  const { isMobile } = useWindowSize({ largeMobile: true })[1];

  const hasValidSearchValues = useMemo(
    () => isThereEvenAValue(giftTableSearchValues),
    [giftTableSearchValues]
  );

  const eventTypeOptions = useMemo(
    () =>
      transformForSelect(eventTypes, 'id', 'name').map((event) => ({
        ...event,
        labels: undefined,
      })),
    [eventTypes]
  );

  const formik = useRef({});

  const history = useHistory();

  const showTable = (table) => {
    if(table.hasOwnProperty('isWap') && table.isWap){
      window.open(`${wapLink}evento/${table.evento}`, '_blank');
      return;
    }
    history.push(getGiftTableLink(table, false));
  };
  const [showSearchForm, setSearchForm] = useState(true)
  const [showList, setShowList] = useState(false)
 
  /* evento que manda para motrar los resultados */
  const handleSubmit = (values) => {
    if (!isThereEvenAValue(values)) {
      listOfGiftsTables.results.list = [];

      dispatch(setGiftTableSearchValues({}));
      return;
    }

    const formattedValues = searchGiftTableFormatter(values);

    dispatch(fetchGiftsTables(formattedValues));
    dispatch(setGiftTableSearchValues(values));

    setShowSearchGiftTable(false);
    setSearchForm(false)
    setShowList(true)
    // console.log('.........show.ist.......')
  };

  const handleClickSearchTable = () => {
    setShowSearchGiftTable(true);
  };

  const handleClose = () => {
    setShowSearchGiftTable(false);
  };

  const handleChange = (page) => {
    const searchValues = giftTable.giftTableSearchValues;

    const pageParam = isMobile ? page.mobilePage : page.page;

    const formattedValues =  searchGiftTableFormatter(searchValues, pageParam);

    dispatch(fetchGiftsTables(formattedValues));

    setShowSearchGiftTable(false);

    window.scrollTo(0, 0);
  };

  const [dataField, setDataField] =  useState('');
  const handleClickDeleteHero = (item) => {
    console.log(item)
    setShowDeleteTableFlux(true);
    setDataField(item)
  };

  const handleCloseDelete = () => {
    setShowDeleteTableFlux(false);
  };


  /* se ejecuta cuando pasas de desktop a movil en responsivo */
  useEffect(() => {

    // console.log('hasValidSearchValues: ', hasValidSearchValues)
    dispatch(fetchEventTypes(false, true, FLAT));

    if (hasValidSearchValues){
      handleShowListWhitContent()
      const formattedValues = searchGiftTableFormatter(giftTableSearchValues);
      dispatch(fetchGiftsTables(formattedValues));
    }else{
      window.sessionStorage.removeItem('clickHomeSearch')
    }

  }, []);
  
  /* se ejecuta cuadno pasas de movil a desktop en responsivo */
  useEffect(() => () => {
    dispatch(resetExternalGiftTable())
  }, []);

  const handleBack = ()=>{
    history.goBack();
  }

  /* evento para regresar y mostrar el form */
  const handleBackList = ()=>{
    if(window.sessionStorage.getItem('clickHomeSearch') === 'true'){
      window.sessionStorage.removeItem('clickHomeSearch')
      history.goBack();
    }else{
      setSearchForm(true)
      setShowList(false)
    }
  }

  /* evento para mostrar resultados cuando tiene datos la primera carga */
  const handleShowListWhitContent = ()=>{
    setSearchForm(false)
    setShowList(true)
  }

/* Form de buscador de eventos */
  const searchGiftTableRender = (
    <Col xs={12} className="p-1">
      <Input
          className={styles.inputborder}
          containerClassName="p-0"
          labelClassName="pl-0 text-left"
          label="Festejado (a)"
          name="eventName"
          placeholder="Nombre del festejado"
          maxLength={50}
      />
      <Input
        className={styles.inputborder}
        containerClassName="p-0"
        labelClassName="pl-0 text-left"
        name="eventNumber"
        label="Número de evento"
        inputMode="numeric"
        maxLength={50}
      />
      {
        !isMobile ? (
          <DatePicker
            className={styles.inputborder}
            containerClassName="p-0"
            labelClassName="pl-0 text-left"
            label="Fecha del evento"
            name="eventDate"
          />
        ) : (
          <Field name="eventDate" component={CustomDatePicker} label='Fecha del evento' maxLength={50} />
        )
      }
      <Select
        label="Tipo de evento"
        selectContainerClassName="p-0"
        labelClassName="pl-0 text-left"
        id="eventType"
        name="eventType"
        options={eventTypeOptions}
        className={styles.inputborder}
        style={{
          border: 'none',
          borderBottomColor: 'currentcolor',
          borderBottomStyle: 'none',
          borderBottomWidth: 'medium',
          borderBottom: '1px solid darkgray !important',
          borderRadius: '0px !important',

        }}
      />
    </Col>
  );

  const totalRegistros = (listOfGiftsTables.results.list.length>0 && listOfGiftsTables.totalElements>0)?listOfGiftsTables.totalElements:0;
  
  // console.log('totalRegistros',totalRegistros);
  
    /* visibe en responsivo movil */
  const searchResultsLengthRender = (
    <p>
      Encontramos {listOfGiftsTables.totalElements} registros que
      coinciden con tu búsqueda
    </p>
  );

  const [searchFocus, setSearchFocus] = useState(false);

  const handleFocus = () => {
    setSearchFocus(true);
  };

  const handleBlur = () => {
    setSearchFocus(false);
  };

  const searchHeader = (
    <div className={`${styles.search} ${searchFocus} ? ${styles.searchFocus}  : ''}`}>
      <div className={styles.line}>
        <input
          type="search"
          className={`${styles.customInput} ml-auto`}
          onFocus={handleFocus}
          onBlur={handleBlur}
          readOnly
          placeholder="Buscar evento"
        />
        <div onClick={handleBackList} role="button">
          <i className={`${styles.searchIcon} fa fa-search`} />
        </div>
      </div>
    </div>
  )
  // console.log(listOfGiftsTables.results.list)

  const deleteItem = useCallback(() => {
    onDeleteGift(item).then(response => {
      response && helpers.setValue(0);
      // setAdd(!!response);
    });
  }, [ onDeleteGift]);

  const giftCards = listOfGiftsTables?.results?.list.map((row, index) => (
    <Col xs={12} className="p-2">
      <div key={index} className="card contentCard">
        {index === 0 && <div className="card-header text-center" >Mesa de regalos</div>}
    
      {/* 
        <div className="card-body d-flex newCardBody" key={index} tabIndex={0} onClick={() => showTable(row)} role="button" >
          <div>
            <h5 className="card-title"><strong>{row.nombre}</strong></h5>
            <p className="card-text">{row.festejados}</p>
          </div>
          <div className="ml-auto">
            <p>{row.fecha}</p>
            
            <div
                id={row.id}
                onClick={() => handleClickDeleteHero(row.id)}
                role="button"
                tabIndex={0}
                className={`${styles.trash} ml-auto`}
            >
                <img
                    src={trash}
                    className={styles.trashIcon}
                    alt="Eliminar"
                />
            </div>
          </div>
        </div>
      */}

        <div className="d-flex newCardBody" key={index} tabIndex={0} onClick={() => showTable(row)} role="button" >
          <h5 className="card-title">{row.festejados}</h5>
          <p className="card-type">{row.tipo}</p>
          <p className="card-date">{row.fecha.replace(/\//g,' ').toLowerCase()}</p>
          <div className="contTwoElemets">
            <p className="card-event">#{row.evento}</p>
            <p className="linkRed">Ir a la mesa</p>
          </div>
        </div>


      </div>
    </Col>
  ));

  // const withoutItems = hasGuestMode ? !hideSoldOutProducts.length : hasEmpty;
  // const inTheLastPage = currentList.length >= data.totalElements;
  // <Link to='..'>Volver atrás</Link>


  return (
    <>
    <DeleteTableFlux show={showDeleteTableFlux} onClose={handleCloseDelete} selectedTable={dataField} />
    {showSearchForm && (
      <>
        <div  className={styles.containerHeaderMovil}> 
          <div className={styles.buttonIconLeft} onClick={handleBack}>
            <i className="fa fa-arrow-left icon" />
          </div>
          <span className={styles.titleName}>Buscar Mesa</span>
        </div>
        <Container className={styles.paddingpage}>        
          <Formik
            innerRef={formik}
            initialValues={{
              ...initialValues,
              ...giftTableSearchValues,
            }}
            validationSchema={schema}
            onSubmit={handleSubmit}
            >
            {(formikProps) => (
                <Form onSubmit={formikProps.handleSubmit}>
                  <Row className="pb-4 mt-lg-3">
                    <Col xs={12} >
                      <div className="justify-content-between align-items-center py-2 my-3">
                      
                        <div className="pl-1 pr-3">
                        <div style={{ textAlign: 'center' }}>
                          <span>Puedes buscar la mesa de regalos con alguno de los siguientes datos.</span>
                        </div>
                          {searchGiftTableRender}
                          <Button className="mb-4 mt-4 mt-lg-3 primaryButton btn" block type="submit">
                          Buscar
                        </Button>
                        </div>
                        <div />
                      </div>
                    </Col>
                  </Row>
                </Form>
            

          )}
          </Formik>
        </Container> 
     
      </>
      )}
       
      { showList && (
        <>
          <div  className={styles.containerHeaderMovil}> 
            <div className={styles.buttonIconLeft} onClick={handleBackList}>
              <i className="fa fa-arrow-left icon" />
            </div>
            <span className={styles.titleName}>Buscar Mesa</span>
          </div>
          <Formik
            innerRef={formik}
            initialValues={{
              ...initialValues,
              ...giftTableSearchValues,
            }}
            validationSchema={schema}
            onSubmit={handleSubmit}
            >
            {(formikProps) => (
                <Form onSubmit={formikProps.handleSubmit}>
                  <Row className="pb-4 mt-lg-3">
                    <Col xs={12} lg={9}>
                      {/* <div className="d-none d-md-block">
                        {totalRegistros > 0 ? searchResultsLengthRender : null}
                      </div> */}
     
                      {listOfGiftsTables.results.list.length ? (

                          <div>

                            <div style={{ textAlign: 'center' }}>
                              {searchHeader}
                              {searchResultsLengthRender}
                            </div>
                          
                            {giftCards}
                          </div>
                      ) : 
                      (
                        <>
                          {searchHeader}
                          <div className={styles.tablecontainer}>
                            <div className={`${styles.ajusteIcono} text-center `}>
                              <img src={searchIcon} alt=""/>
                              <p className="mt-5">Lo sentimos, no encontramos ninguna mesa <br/> con los datos ingresados</p>
                            </div>
                          </div>
                        {/*                           
                          <div >
                            <Col xs={12} md={12} lg={12} className={styles.buttoncontainer}>
                              <a className="link-button center" href={setLoginRedirectSSO('crear-mesa', true, isLoggedIn, true)}>
                                <Button variant="primary" className={`border-0 px-4 ${styles.mobileButton}`}>
                                  Crear mi mesa de regalos
                                </Button>
                              </a>
                            </Col>
                          </div>
                          <div  >
                            <Col xs={12} md={12} lg={12} className={styles.buttoncontainer}>
                              <Button variant="secundary" onClick={() => setSearchForm(true)}>Buscar mesa</Button>
                            </Col>
                          </div> 
                        */}
                        </>
                        )

                      }
                    </Col>
                  </Row>
                </Form>
            )}
          </Formik>
          </>
        )}
    </>
  );
}

export default SearchTableStep;
